import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Rebound Net fielded by receiving team fragment for Indoor Football.
 * When the ball hits the rebound net on a kickoff and is fielded by the receiving team.
 * This changes possession (receiving team gains possession).
 */
export default class ReboundNetFieldedReceiving extends Fragment {
    constructor(fieldedBy, fieldedAt) {
        super();
        this.code = "RBNFR";
        this.fieldedBy = fieldedBy;
        this.fieldedAt = fieldedAt;

        this.requiredData = [
            {
                name: "fieldedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Fielded By",
                title: (team) => `Fielded By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "fieldedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    changesPossession() {
        return true;
    }

    getFieldPosition() {
        return this.fieldedAt;
    }

    getPlayers() {
        return [this.fieldedBy];
    }

    getFragmentTeamId() {
        return this.fieldedBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        const message = `fielded by ${stringifier.firstInitial(
            this.fieldedBy
        )}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.homeTeamHasPossession =
            this.fieldedBy?.teamId === summaryContext.homeTeamId;
        if (this.fieldedAt || this.fieldedAt === 0) {
            summaryContext.fieldPosition = this.fieldedAt;
        }
        summaryContext.playerInPossession = this.fieldedBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            fieldedBy: playerReducer(this.fieldedBy)
        };
    }
}
